<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper notEnoughGold" style="z-index: 1135; opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal small  notEnoughGold " ng-class="{inWindowPopupOpened: inWindowPopupOpened}">
				<div class="modalContent" ng-style="{minHeight: w.getOverlayHeightWithPadding(-10) || 'none'}">
					<div class="functionPanel">
						<a ng-if="w.params.modalParams.closeable" clickable="closeWindow('confirmAction')" class="closeWindow clickable"  play-on-click="7" @click="onModalClose(close)" content="Закрыть" v-tippy="{placement: 'bottom'}">
							<i class="closeWindow" :class="{'action_cancel_small_flat_black': !cancelHover, 'action_cancel_small_flat_green': cancelHover}" @mouseover="cancelHover = true" @mouseleave="cancelHover = false"></i>
						</a>
					</div>
					<div class="contentHeader">
						<h2 ng-if="!w.contentHeaderText" class=" msAntiScroll" draggable="true">
							<span translate="" options="Payment.NotEnoughGold.Headline" data=""><span>Недостаточно золота</span></span>
						</h2>
						<!-- ngIf: w.contentHeaderText -->
					</div>
					<div class="notEnoughGold" ng-controller="notEnoughGoldCtrl">
						<div class="packageDescription" translate=""><span>У тебя недостаточно золота для использования этой функции.</span></div>
						<i class="shop_bankPackage3_huge_illu"></i>
						<div data="goto:openShop()" translate=""><span>Вы можете </span><a clickable="openShop()" class="clickable">зайти в магазин</a><span> или перейти сразу к подходящему по ситуации предложению.</span></div>
						<div class="horizontalLine"></div>
						<button ng-if="shopAvailable" class="buy clickable" clickable="openShop(true)" @click="onModalClose(close)">
							<div class="content">
								<span ng-transclude="" class="innerText">
									<span translate=""><span>Открыть предложение</span></span>
								</span>
								<!-- ngIf: price > 0 || forceGoldUsage -->
								<!-- ngIf: price == -1 && !forceGoldUsage -->
								<div class="animationOverlay"></div>
								<i class="checkmark action_check_small_flat_white"></i>
								<i class="checkmark action_check_small_flat_black"></i>
								<i class="checkmark action_check_small_flat_red"></i>
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>